//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TreeViewHeaderContextMenu from './TreeViewHeaderContextMenu.vue';
import TreeViewSettings from './TreeViewSettings.vue';

export default {
  name: 'DpModelViewHeader',
  components: {
    TreeViewHeaderContextMenu,
    TreeViewSettings,
  },
  props: {
    columns: { type: Array, default: null, required: true },
    rows: { type: Array, default: () => [] },
    locked: { type: Boolean, default: false },
  },
  data() {
    return {
      dragColumn: null,
      resizingColumn: null,
      resizingElement: null,
      contextMenuColumnIndex: null,
      contextMenuDisableRemove: false,
      settingsVisible: false,
    };
  },
  methods: {
    getColumnStyle(column) {
      const { width } = column;
      if (!width) {
        return null;
      }
      return {
        flex: `0 0 ${width}`,
      };
    },
    drag(ev, column) {
      if (this.locked) {
        ev.preventDefault();
        return;
      }
      this.dragColumn = column;
    },
    dragover() {},
    drop(ev, column) {
      this.$emit('move-column', { from: this.dragColumn, to: column });
      this.dragColumn = null;
    },
    startResize(ev, column) {
      if (this.locked) {
        ev.preventDefault();
        return;
      }

      this.resizingColumn = column;

      const element = ev.target.parentElement;
      this.resizingElement = element;

      this.moveResize(ev);
    },
    endResize(ev) {
      if (!this.resizingColumn) {
        return;
      }

      const { headerElement } = this.$refs;
      const tableWidth = headerElement.clientWidth;

      const cell = this.resizingElement;
      const cellX = cell.getBoundingClientRect().left;
      const mouseX = ev.clientX;

      const cellDelta = mouseX - cellX;
      // Rounded to two decimal places
      const cellPercentOfTable = Math.round((cellDelta / tableWidth) * 100) / 100;

      const width = `${cellPercentOfTable * 100}%`;

      let columnIndex;
      this.columns.forEach((col, index) => {
        if (col === this.resizingColumn) {
          columnIndex = index;
        }
      });

      this.setColumnWidth(columnIndex, width);

      this.resizingColumn = null;
      this.resizingElement = null;
    },
    moveResize(ev) {
      if (!this.resizingColumn) {
        return;
      }

      const container = this.$el.getBoundingClientRect();
      const left = ev.clientX - container.left;

      this.$refs.resizeIndicator.style.left = `${left}px`;
    },
    toggleSort(index) {
      if (this.locked) return;
      const column = this.columns[index];
      let order = 'asc';
      if (column.sort && column.sort === 'asc') {
        order = 'desc';
      }

      this.$emit('change-sort', {
        columnIndex: index,
        order,
      });
    },
    openContextMenu(ev, { column, index }) {
      this.contextMenuColumnIndex = index;
      this.contextMenuDisableRemove = column.type === 'kpi';
      this.$refs.contextMenu.open(ev);
    },
    closeContextMenu() {
      this.contextMenuColumnIndex = null;
    },
    handleContextMenuAction(action) {
      if (!this.contextMenuColumnIndex) return;
      switch (action) {
        case 'reset': this.setColumnWidth(this.contextMenuColumnIndex, null); break;
        case 'remove': this.removeColumn(this.contextMenuColumnIndex); break;
        default: break;
      }

      this.closeContextMenu();
    },
    setColumnWidth(columnIndex, width) {
      this.$emit('resize-column', {
        columnIndex,
        width,
      });
    },
    removeColumnByProperty(property) {
      const index = this.columns.findIndex((col) => col.property === property.field);
      if (index !== -1) {
        this.removeColumn(index);
      }
    },
    removeColumn(columnIndex) {
      this.$emit('remove-column', columnIndex);
    },
    toggleSettings() {
      this.settingsVisible = !this.settingsVisible;
    },
  },
};
